function convertToDropDownOptions(
  arr: {
    id?: number | string
    value: string
    display_id?: number | string
    title?: string
    name?: string
  }[]
): DropDownOption[] {
  return arr.map((item) => {
    return {
      value: item.id! || item.display_id!,
      label: item.title! || item.name! || item.value,
    }
  })
}

function mappingCustomFields(customFields: any[]): CustomField[] {
  return customFields.map((field: any) => {
    return {
      name: field.label,
      id: field.name,
      label: null,
      value: field.field_type === 'custom_static_rich_text' ? field.label : null,
      choices: field.choices,
      isRequired: field.required,
      type: field.field_type,
      sections: field.sections || [],
      currSection: null,
      fieldOptions: field.field_options || null,
    }
  })
}

function getTicketFields(mappingTicketFields: TicketFields, ticketFieldsData: any[]) {
  const ticketFields: { [key: string]: null | DropDownOption } = {}

  ticketFieldsData.forEach(ticketField => {
    const converedtFreshFieldName = convertFreshFieldName(ticketField?.name)
    ticketFields[converedtFreshFieldName] = mappingTicketFields[converedtFreshFieldName as keyof TicketFields] || null
  })
  return ticketFields
}

function convertMondayFieldName(fieldName: string): string {
  let ticketField: string = ''
  switch (fieldName) {
    default:
      ticketField = fieldName
      break
    case 'subject':
      ticketField = 'Subject'
      break
    case 'email':
      ticketField = 'Requester Email'
      break
    case 'id_column':
      ticketField = 'Ticket ID'
      break
    case 'ticket_link':
      ticketField = 'Ticket Link'
      break
    case 'requested_for':
      ticketField = 'Requested For'
      break
    case 'category_id':
      ticketField = 'Categories'
      break
    case 'catalog_id':
      ticketField = 'Catalog'
      break
  }
  return ticketField
}

function convertFreshFieldName(fieldName: string): string {
  let ticketField: string = ''
  switch (fieldName) {
    default:
      ticketField = fieldName
      break
    case 'department':
      ticketField = fieldName + '_id'
      break
    case 'group':
      ticketField = fieldName + '_id'
      break
    case 'agent':
      ticketField = 'responder_id'
      break
  }
  return ticketField
}

export const utilService = {
  convertToDropDownOptions,
  mappingCustomFields,
  getTicketFields,
  convertMondayFieldName,
  convertFreshFieldName,
}
